module.exports = require('./helpers/bundle-url').getBundleURL('bGmkp') + "logo.c51670a8.svg";